import script from "./ScalperUser.vue?vue&type=script&lang=ts&setup=true&name=ScalperUser"
export * from "./ScalperUser.vue?vue&type=script&lang=ts&setup=true&name=ScalperUser"

const __exports__ = script;

export default __exports__